






import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {loadedGoogleMapsAPI} from "@/plugins/maps.plugin";

declare const google: any;

@Component({})
export default class Map extends Vue {
  @Prop() params!: { userId: null, date: null };
  @Prop() storeID!: '';
  map: any = '';
  mapCenter = {lat: 45.262231, lng: 19.8518579};
  marker: any = '';
  infoWindow: any = '';

  visits = [];
  markers = [];

  async mounted() {
    loadedGoogleMapsAPI.then(() => {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: this.mapCenter,
        zoom: 8
      });
      this.infoWindow = new google.maps.InfoWindow();
    });
  }

  @Watch('params', {deep: true})
  async onParamsChange() {
    if (this.params.userId && this.params.date) {
      await this.axios.get('api/GetVisitedLocationsByUser', {
        params: {
          userId: this.params.userId,
          date: this.params.date
        }
      }).then(result => {
        this.visits = result.data;
      });
    }
    if (this.visits.length > 0) {
      let bounds = new google.maps.LatLngBounds(), position;
      for (let i = 0; i < this.visits.length; i++) {
        let visit = this.visits[i];
        position = new google.maps.LatLng(visit.latitude, visit.longitude);
        bounds.extend(position);
        this.marker = new google.maps.Marker({
          map: this.map,
          position: position,
          title: visit.store
        });
        this.marker.storeID = visit.storeID;
        this.addInfo(this.marker, visit);
        this.markers.push(this.marker);
        this.map.fitBounds(bounds);
      }
      let polyline = new google.maps.Polyline({
        path: this.visits.map(visit => {
          return {lat: visit.latitude, lng: visit.longitude}
        }),
        strokeColor: '#438eb9',
        strokeOpacity: 0.7,
        map: this.map
      });
    } else {
      loadedGoogleMapsAPI.then(() => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: this.mapCenter,
          zoom: 8
        });
      });
    }
  }

  @Watch('storeID') onStoreIDChange(value) {
    this.markers.forEach(marker => {
      if (marker.storeID === value.storeID) {
        marker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          marker.setAnimation(null);
        }, 2000);
      }
    });
  }

  addInfo(marker, visit) {
    marker.addListener('click', () => {
      let content = ["<h6>", visit.store, "</h6>",
        "<p>" + this.$i18n.t('aktivnost') +  ":<strong>", visit.activities, "</strong></p>",
        "<p>", this.$i18n.t('vremeObrade') , "<strong>", visit.time || "-", " min</strong>", "</p>"
      ].join('');

      this.infoWindow.setContent(content);
      this.infoWindow.open(this.map, marker);
    });
  }

}
